import React from 'react';
import { Card, Button } from 'antd';
import styles from './s.module.less';
import capitalize from 'lodash/capitalize';

interface QuestionCardProps {
    question: string;
    subtext: string;
    type?: string;
    onEdit?: () => void;
}

const QuestionCard: React.FC<QuestionCardProps> = ({ question, subtext, type, onEdit }) => {
    return (
        <Card className={styles.infoCard} bordered={false}>
            <div className={styles.paymentHeader}>
                <span className={styles.paymentTitle}>{capitalize(type)}</span>
                <Button onClick={onEdit}>Edit</Button>
            </div>
            <div className={styles.paymentContent}>
                <div className={styles.paymentItem}>
                    <div className={styles.paymentLabel}>Question</div>
                    <div className={styles.paymentText}>{question}</div>
                </div>
                <div className={styles.paymentItem}>
                    <div className={styles.paymentLabel}>Subtext</div>
                    <div className={styles.paymentText}>{subtext}</div>
                </div>
            </div>
        </Card>
    ); };

export default QuestionCard;
